import { IRapportInfo } from '../../../../../Types/RapportInfoType';
// import { rapportInfos } from '../RapportInfo';

const TIRapportMeny: IRapportInfo[] = [];

export default TIRapportMeny;
